module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.authenticated) ? _c('div', {
    staticClass: "app"
  }, [_c('notifications'), _vm._v(" "), _c('AppHeader'), _vm._v(" "), _c('div', {
    staticClass: "app-body"
  }, [_c('Sidebar'), _vm._v(" "), _c('main', {
    staticClass: "main"
  }, [_c('breadcrumb', {
    attrs: {
      "list": _vm.list
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "container-fluid"
  }, [_c('router-view')], 1)], 1)], 1), _vm._v(" "), _c('AppFooter')], 1) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-aab40966"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/containers/Full.vue
// module id = 591
// module chunks = 0